<div class="cpcontent">
    <h2>Formfields</h2>
    Formfields are defined in folder shared/formfields
    <br><br>
    <div class="row">
        <div class="col-md-4">
            <sa-input-text [(text)]="test.name" [title]="'Name of test' "></sa-input-text>
            <sa-input-number [(text)]="test.age" [title]="'Age' "></sa-input-number>
        </div>
        <div class="col-md-4">
            <sa-label [(text)]="test.label" [title]="'a label' "></sa-label>
            <sa-input-textarea [(text)]="test.longtext" [title]="'Name of test' "></sa-input-textarea>
        </div>
        <div class="col-md-4">
            <sa-input-boolean [(checked)]="test.isHuman" [title]="'Is a human?' "></sa-input-boolean>
            <sa-select [(Id)]="test.colorid" [title]="'Color'" [options]="colors"></sa-select>
        </div>
    </div>
    Test Object with double binding
    <pre [innerHTML]="test | json"></pre>
</div>